module.exports = {"labels":{"motivation":"Motivo","details":"Conte mais detalhes (Opcional)","choice":"escolha","insert":"EX o que deve ser inserido"},"errorMessages":{"emptyField":"Campo obrigatório"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/ContestationForm/data.json
// module id = 1836
// module chunks = 0